import { queryOptions } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { ClientListParams } from '@/lib/api/domains/clients';
import type { ClientId } from '@/lib/api/ids';
import { keys } from '@/lib/query-keys';

/** Consumption layer for clients (mirrors invoices' shape). */
export function clientListQuery(params: ClientListParams) {
  return queryOptions({
    queryKey: keys.clients.list(params),
    queryFn: () => api.clients.list(params),
    staleTime: 30_000,
  });
}

export function clientDetailQuery(clientId: ClientId) {
  return queryOptions({
    queryKey: keys.clients.detail(clientId),
    queryFn: () => api.clients.get(clientId),
    staleTime: 30_000,
  });
}
